module.exports = __webpack_public_path__ + "static/media/address-card.0b12ffd3.svg";